export const SIMPLE = '__SIMPLE_API__';
export const NO_CONTENT = 204;



// WEBPACK FOOTER //
// ./node_modules/@localytics/redux-simple-api-middleware/lib/constants.js